import { defineMessages } from 'react-intl.macro';
import { FormattedMessage } from 'react-intl';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { AppState, useDispatch } from '@tmapy/redux';
import { BtnBar, CtaBtn } from '@tmapy/style-guide';

import { useHistoryAction } from '../hooks';
import { PageTitle } from '../app/components/PageTitle';
import { MainContent } from '../app/components/MainContent';
import { setMenuRouteFilterId } from '../redux/menu/actions';

const msg = defineMessages({
  title: {
    id: 'manager.home.title',
    defaultMessage: 'Vítejte v aplikaci Manažer',
  },
  description: {
    id: 'manager.home.description',
    defaultMessage:
      'Aplikace slouží ke správě online předaných geodetických dokumentací skutečného provedení stavby výkonnému správci Digitální technické mapy.',
  },
  new: {
    id: 'manager.home.new',
    defaultMessage: 'Vložit dokumentaci',
  },
  check: {
    id: 'manager.home.check',
    defaultMessage: 'Kontrola dokumentace',
  },
});

export const ManagerHome = () => {
  const { customerType } = useSelector((state: AppState) => state.app.config);
  const dispatch = useDispatch();

  const historyActionIdent = useMemo(() => {
    switch (customerType) {
      case 'dtm':
        return 'podaniDTINew';
      case 'cepro':
        return 'ceproDocNew';
      case 'bb':
        return 'bbDocNew';
      default:
        return null;
    }
  }, [customerType]);

  const handleNewDocClick = useHistoryAction(historyActionIdent);
  const handleNewCheckClick = useHistoryAction('managerNewCheck');

  const isCheckVisible = !['cepro', 'bb'].includes(customerType);

  useEffect(() => {
    // reset menuRouteFilterId
    dispatch(setMenuRouteFilterId(''));
  });

  return (
    <MainContent>
      <div className='sg-u-vs-4'>
        <PageTitle>
          <FormattedMessage {...msg.title} />
        </PageTitle>
        <p>
          <FormattedMessage {...msg.description} />
        </p>
        <BtnBar align='left'>
          <CtaBtn onClick={handleNewDocClick}>
            <FormattedMessage {...msg.new} />
          </CtaBtn>
          {isCheckVisible && (
            <CtaBtn onClick={handleNewCheckClick}>
              <FormattedMessage {...msg.check} />
            </CtaBtn>
          )}
        </BtnBar>
      </div>
    </MainContent>
  );
};
